// Ensure consistent Symbol.observable across the application
if (!(Symbol as any).observable) {
  ;(Symbol as any).observable = Symbol('observable')
}

// Export empty object to make this a module
export {}
